// extracted by mini-css-extract-plugin
module.exports = {"slider":"_3dQNV","slide":"_2kklr","description":"LzfPc","badges":"_3EkVY"};